import { LocalStorage } from 'enums/localStorage';
import * as jose from 'jose';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const getQueryVariable = (variable: any, search = '') => {
  const query = search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === variable) {
      return decodeURIComponent(pair[1]);
    }
  }

  return null;
};

export const cookieDomain =
  // eslint-disable-next-line no-nested-ternary
  process.env.NEXT_PUBLIC_ORIGIN === 'https://jaimystaging.be'
    ? '.jaimystaging.be'
    : process.env.NEXT_PUBLIC_ORIGIN === 'https://jaimy.be'
    ? '.jaimy.be'
    : '.jaimy.be';

export const getJaimyCookie = (logInToken: jose.JaimyJWTPayload) => {
  const jaimyCookie =
    Cookies.get('jaimyCookie') &&
    JSON.parse(Cookies.get('jaimyCookie') as string);

  const gclidLocalStorage = window.sessionStorage.getItem(
    LocalStorage.GCLID_PARAMETERS,
  );

  const utmParams =
    window.sessionStorage.getItem(LocalStorage.UTM_PARAMETERS) || `{}`;

  const utmParametersLocalStorage = JSON.parse(utmParams);
  const utmSourceLocalStorage = utmParametersLocalStorage?.utmSource;
  const utmMediumLocalStorage = utmParametersLocalStorage?.utmMedium;
  const utmCampaignLocalStorage = utmParametersLocalStorage?.utmCampaign;

  const utm_campaign =
    getQueryVariable('utm_campaign', window.location.search) ||
    utmCampaignLocalStorage;
  const utm_medium =
    getQueryVariable('utm_medium', window.location.search) ||
    utmMediumLocalStorage;
  const utm_source =
    getQueryVariable('utm_source', window.location.search) ||
    utmSourceLocalStorage;

  const gclid =
    gclidLocalStorage || getQueryVariable('gclid', window.location.search);
  const fbclid =
    gclidLocalStorage || getQueryVariable('fbclid', window.location.search);
  const msclkid =
    gclidLocalStorage || getQueryVariable('msclkid', window.location.search);

  let clid_type: string | undefined;

  const gclidHandler = () => {
    if (gclid) {
      clid_type = 'google';
      return gclid;
    }
    if (fbclid) {
      clid_type = 'facebook';
      return fbclid;
    }
    if (msclkid) {
      clid_type = 'bing';
      return msclkid;
    }
    return undefined;
  };

  if (jaimyCookie && jaimyCookie.uuid) {
    const jaimyCookieUpdate = {
      ...jaimyCookie,
      trader_id: logInToken.trader_id,
      utm_source: jaimyCookie.utm_source ? jaimyCookie.utm_source : utm_source,
      utm_campaign,
      utm_medium,
    };

    Cookies.set('jaimyCookie', JSON.stringify(jaimyCookieUpdate), {
      expires: 180,
      domain: cookieDomain || 'jaimy.be',
    });
    return jaimyCookieUpdate;
  }
  if (!jaimyCookie) {
    const jaimyCookieNew = {
      uuid: uuidv4(),
      clid_id: gclidHandler(),
      clid_type,
      trader_id: logInToken.trader_id,
      utm_campaign,
      utm_medium,
      utm_source,
    };
    Cookies.set('jaimyCookie', JSON.stringify(jaimyCookieNew), {
      expires: 180,
      domain: cookieDomain || '.jaimy.be',
    });
    return jaimyCookieNew;
  }

  return (
    Cookies.get('jaimyCookie') &&
    JSON.parse(Cookies.get('jaimyCookie') as string)
  );
};
